import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * @deprecated
 *
 * This component is under review and will most likely be removed in the future. If you need to use
 * this please discuss in #design-system channel in slack!
 */
@Component({
  selector: 'fin-titled-card',
  templateUrl: './titled-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitledCardComponent {
  @Input()
  title: string;
}
